module.exports = __webpack_public_path__ + "img/title-coupon.d5093099.png";